<template>
<v-card flat >
  <!-- @reload = 'getStatement' -->
  <statement
    v-if='invoice && invoice.id'
    v-model='statement'
    @reload = 'getStatement'
    :client='invoiceClient'
    :with-selectable = 'true'
    :with-reload = 'true'
    :with-pre-next = 'false'
    :with-filters = 'false'
    :with-client-preview = 'false'
    :loading='statementRequest.loading' >
    <template slot="subheader" >
      <slot name="subheader"></slot>
    </template>
  </statement>
</v-card>
</template>

<script>
import Statement from '@/components/statement'
import StatementMixin from '@/mixins/statement.js'

export default {
  name: 'InvoicePayments',
  mixins: [StatementMixin],
  components: { Statement },
  props: {
    invoice: { type: Object },
    transactions: { type: Array, default: () => { return [] } }
  },
  // data () {
  //   return {
  //     statementRequestId: 'invoice-detail-statement'
  //   }
  // },
  // mounted () {
  //   this.getStatement()
  // },
  // methods: {
  //   getStatement () {
  //     if (this.invoice.appointments && this.invoice.appointments.length > 0) {
  //       let params = {
  //         appointments: this.invoice.appointments.join(',')
  //       }
  //       // 1244
  //       this.$appointmentguru
  //         .resource('v3.statement')
  //         .id(this.statementRequestId)
  //         .get(this.invoice.customer_id, params)
  //     }
  //   }
  // },
  watch: {
    invoice: {
      immediate: true,
      handler () {
        this.getStatement()
      }
    }
  },
  computed: {
    invoiceClient () {
      return this.getClientById(this.invoice.customer_id)
    },
    // statementRequest () {
    //   return this.$store.getters.getRequestById(this.statementRequestId, true)
    // },
    appointmentIds () {
      if (this.invoice && this.invoice.appointments) {
        return this.invoice.appointments
      }
      return []
    },
    statement () {
      return this.getObjectPath(this.statementRequest, 'result', {})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// InvoicePayments.vue?7b13c87f